import {
  RecomendationApiRequest,
  DeleteRecomendationRequest,
} from '@/data/payload/api/RecomendationRequest'
import {
  PostRecomendationInterface,
  DeleteRecomendationInterface,
} from '@/data/payload/contracts/RecomendationRequest'
import ApiService from '@/app/framework/services/ApiServices'
import { RecomendationDataMapper } from '@/data/persistences/mappers/RecomendationDataMapper'
import { RecomendationRepositoryInterface } from '@/data/persistences/repositories/contracts/RecomendationRepositoryInterface'
import { Recomendation } from '@/domain/entities/Recommendation'
import { Endpoints } from '@/app/framework/misc/Endpoints'

export class RecomendationApiRepository
  implements RecomendationRepositoryInterface {
  private service: ApiService
  private mapper: RecomendationDataMapper

  constructor(service: ApiService, mapper: RecomendationDataMapper) {
    this.service = service
    this.mapper = mapper
  }

  public async getAll(params: Object): Promise<Recomendation> {
    const resp = await this.service.invoke(
      'get',
      Endpoints.Route.RECOMENDATION,
      params
    )
    return this.mapper.convertRecomendationFromApi(resp)
  }

  public async post(
    payload: PostRecomendationInterface
  ): Promise<Recomendation> {
    const resp = await this.service.invoke(
      'post',
      Endpoints.Route.RECOMENDATION,
      undefined,
      payload as RecomendationApiRequest
    )
    return this.mapper.convertBaseResponseFromApi(resp)
  }

  public async delete(
    payload: DeleteRecomendationInterface
  ): Promise<Recomendation> {
    const resp = await this.service.invoke(
      'post',
      Endpoints.Route.RECOMENDATION_DELETE,
      undefined,
      payload as DeleteRecomendationRequest
    )
    return this.mapper.convertBaseResponseFromApi(resp)
  }
}
